import { index, pgTable, uuid } from "drizzle-orm/pg-core";
import { createInsertSchema, createSelectSchema } from "drizzle-zod";
import { z } from "zod";

import { householdMemberDocumentsTable } from "./householdMemberDocumentsSchema";
import { customDate, customTimestamp } from "./utils/types";
import { workRequirementHouseholdMembersTable } from "./workRequirementHouseholdMembersSchema";

// Links a regular uploaded document to the work requirement proof it satisfies.
// Deleting the document cascades here so progress counts stay accurate.
export const workRequirementDocumentsTable = pgTable(
  "work_requirement_documents",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    workRequirementHouseholdMemberId: uuid(
      "work_requirement_household_member_id",
    )
      .references(() => workRequirementHouseholdMembersTable.id, {
        onDelete: "cascade",
      })
      .notNull(),
    householdMemberDocumentId: uuid("household_member_document_id")
      .references(() => householdMemberDocumentsTable.id, {
        onDelete: "cascade",
      })
      .notNull()
      .unique(),
    // First day of the month a proof of work covers; null for proof of exemption.
    coverageMonth: customDate("coverage_month"),
    createdAt: customTimestamp("created_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString()),
  },
  table => [
    index("work_requirement_documents_wr_household_member_id_index").on(
      table.workRequirementHouseholdMemberId,
    ),
  ],
);

export const insertWorkRequirementDocumentSchema = createInsertSchema(
  workRequirementDocumentsTable,
  {
    workRequirementHouseholdMemberId: z.uuid(),
    householdMemberDocumentId: z.uuid(),
    coverageMonth: z.iso.date().nullish(),
  },
).omit({
  id: true,
  createdAt: true,
});
export type InsertWorkRequirementDocumentType = z.infer<
  typeof insertWorkRequirementDocumentSchema
>;

export const workRequirementDocumentSchema = createSelectSchema(
  workRequirementDocumentsTable,
);
export type WorkRequirementDocumentType = z.infer<
  typeof workRequirementDocumentSchema
>;
